import BuildOutlinedIcon from "@material-ui/icons/BuildOutlined";

export default {
  icon: BuildOutlinedIcon,
};
